

















import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const error = namespace('error')

@Component
export default class Error extends Vue {
  @error.Getter error!: any
  dialog = false

  @Watch('error')
  showError() {
    this.dialog = true
  }

  close() {
    this.dialog = false
  }
}
